<template>
  <li class="dropdownItem dropdownItem__managerInfo">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      使用者: {{ name }}({{ position }})
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-left">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="{ name: 'ManagerList' }"
          v-if="permissionUserManagement"
        >
          使用者管理
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="{ name: 'AbilityManagement' }"
          v-if="permissionPositionManagement"
        >
          職位管理
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="{ name: 'LoginInfoList' }"
          v-if="permissionUserBehavior"
        >
          使用者行為紀錄
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="{ name: 'CustomerComplaint' }"
        >
          客訴管理
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <a @click="$emit('logout')" class="dropdownItem__href">
          <i class="fa fa-sign-out pull-right"></i>
          登出
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
    },
    position: {
      type: String,
    },
    permissionUserManagement: {
      type: Boolean,
    },
    permissionUserBehavior: {
      type: Boolean,
    },
    permissionPositionManagement: {
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownManagerInfo.vue